import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

// Creator categories (the "niche" field) moved from a hardcoded array to the
// creator_categories table (2026-07-27) so the CEO can add/rename/merge them
// from Settings without a deploy. This context fetches the list once at app
// load and exposes `refresh()` so the Manage Categories panel can update
// every consumer immediately after an add/rename/merge, matching the
// backend's "query fresh, no stale cache" behavior.
const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const [rows, setRows]             = useState([]); // {id, name, sort_order} — Manage Categories needs ids
  const [categories, setCategories] = useState([]); // just names — what every select/multi-select consumes
  const [loading, setLoading]       = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await fetch('/api/creator-categories', { credentials: 'include' });
      const d = await r.json();
      if (d.success) { setRows(d.data); setCategories(d.data.map(c => c.name)); }
    } catch { /* keep last known list on transient fetch failure */ }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  return (
    <CategoriesContext.Provider value={{ categories, rows, loading, refresh }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  return useContext(CategoriesContext);
}
